import React from 'react';
import TagSkeleton from './TagSkeleton';

const BulkTagSkeleton = function BulkTagSkeleton() {
  return (
    <>
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
      <TagSkeleton />
    </>
  );
};

export default BulkTagSkeleton;
